<template>
  <div class="content">
    <el-card class="box-card" >
        <div slot="header" class="clearfix">
          <span style="font-weight: bolder">运营统计</span>
        </div>
        <div class="order">
          <div class="lists" style="background: linear-gradient(to right, #8B77FD, #AEA4FD);">
            <svg-icon icon-class="pool-balance" class-name="pool-icon" />
            <div class="amount">
              <p style="font-size: 22px;color:#fff">账户余额</p>
              <p style="font-size: 22px;color:#fff">
                ￥<countTo :startVal="startVal" :endVal="totalStatisticData.accountBalance" :duration="2000"></countTo>
              </p>
            </div>
          </div>
          <div class="lists" style="background: linear-gradient(to right, #5391FF, #77A8FE);">
            <svg-icon icon-class="pool-number" class-name="pool-icon" />
            <div class="amount">
              <p style="font-size: 22px;color:#fff">SIM总数</p>
              <p style="font-size: 22px;color:#fff">
                <countTo :startVal="startVal" :endVal="totalStatisticData.totalCardNumber" :duration="2000"></countTo>张
              </p>
            </div>
          </div>
          <div class="lists" style="background: linear-gradient(to right,#EE9572,	#EE9A00);">
            <svg-icon icon-class="pool-add" class-name="pool-icon" />
            <div class="amount">
              <p style="font-size: 22px;color:#fff">本月新增卡</p>
              <p style="font-size: 22px;color:#fff">
                <countTo :startVal="startVal" :endVal="totalStatisticData.currentMonthAddCardNumber" :duration="2000"></countTo>张
              </p>
            </div>
          </div>
          <div class="lists" style="background: linear-gradient(to right, #4CC0B3, #85D2CA);">
            <svg-icon icon-class="pool-activation" class-name="pool-icon" />
            <div class="amount">
              <p style="font-size: 22px;color:#fff">月活跃卡</p>
              <p style="font-size: 22px;color:#fff">
                <countTo :startVal="startVal" :endVal="totalStatisticData.monthActiveCardNumber" :duration="2000"></countTo>张
              </p>
            </div>
          </div>
          <div class="lists" style="background: linear-gradient(to right, #F28A67, #F7B6A4);" @click="stopInfo">
            <svg-icon icon-class="pool-warning" class-name="pool-icon" />
            <div class="amount" >
              <p style="font-size: 22px;color:#fff">停机预警</p>
              <p style="font-size: 22px;color:#fff">
                <countTo :startVal="startVal" :endVal="totalStatisticData.stopCardNumber" :duration="2000"></countTo>张
              </p>
            </div>
          </div>
        </div>
    </el-card>

    <el-tabs v-model="activePoolId" @tab-click="handleTabClick">
      <el-tab-pane :label="item.poolName" :name="item.id" :key="index" v-for="(item,index) in pondList"></el-tab-pane>
    </el-tabs>

    <el-card  class="box-card" >
      <el-row>
          <el-col :xs="24"  :lg="8">
            <span style="font-weight: bolder">卡运营商分布</span>
            <div id="cardOperatorEcharts" style="width: 100%;height: 300px;" ></div>
          </el-col>
          <el-col :xs="24"  :lg="8">
            <span style="font-weight: bolder">卡生命周期分布</span>
            <div id="lifeCycleEcharts" style="width: 100%;height: 300px;" ></div>
          </el-col>
          <el-col :xs="24"  :lg="8">
              <span style="font-weight: bolder">月入池卡数统计</span>
              <div id="cardNumberByMonthEcharts" class="cardNumberByMonthEchartsClass" ></div>
          </el-col>
      </el-row>
    </el-card>

    <el-card  class="box-card" v-if="adminShow">
        <el-row>
          <el-col :xs="24"  :lg="9">
            <span style="font-weight: bolder">近六月费用</span>
            <div id="sixMonthsEcharts" class="sixMonthsEchartsClass" ></div>
          </el-col>
          <el-col :xs="24"  :lg="9" >
            <span style="font-weight: bolder">流量使用量</span>
            <div style="position: absolute; right:29.5%;top:11%;height:50%;z-index: 999;" >
              <el-radio-group v-model="flowUsageMode"  @change="changeFlowUsageMode" >
                <el-radio-button label="按日" >按日</el-radio-button>
                <el-radio-button label="按月" >按月</el-radio-button>
              </el-radio-group>
            </div>
            <div id="flowUsageEcharts" class="flowUsageEchartsClass" ></div>
          </el-col>
          <el-col :xs="24"  :lg="6">
            <span style="font-weight: bolder;">卡月流量TOP</span>
            <div class="top-content">
                <p class="table-head"><span>ICCID</span><span>使用量 (MB)</span></p>
                <ul v-if="cardMonthFlowTopData.length > 0">
                  <li v-for="(item,index) in cardMonthFlowTopData" :key="index" class="topCard">
                    <div>
                      <span class="number-bg">{{index + 1}}</span>
                      <span @click="cardInfo(item.name)">{{item.name}}</span>
                    </div>
                    <div>
                      <span>{{item.value}}</span>
                    </div>
                  </li>
                </ul>
                <div v-else class="top-default">暂无数据</div>
            </div>
          </el-col>
        </el-row>
    </el-card>

    <el-card class="box-card" >
        <el-row>
          <el-col :xs="24"  :lg="9">
            <span style="font-weight: bolder">本月流量使用情况</span>
            <div id="currentMonthFlowEcharts" class="currentMonthFlowEchartsClass" style="height: 400px;background: white" ></div>
          </el-col>
          <el-col :xs="24"  :lg="15">
            <span style="font-weight: bolder">历史用量</span>
            <div id="historyUsageEcharts" class="historyUsageEchartsClass"  style="width:99%;height: 400px;"></div>
          </el-col>
        </el-row>
    </el-card>

  </div>
</template>
<script>
import * as echarts from "echarts";
import "echarts-liquidfill";
import countTo from "vue-count-to";
import {
  poolGetFlowPoolList,
  cardOperatorPieData,
  lifeCyclePieData,
  cardNumberByMonthBarData,
  sixMonthsExpenseBarData,
  cardMonthFlowTopData,
  currentMonthFlowData,
  historyUsageData,
  totalStatisticData, flowUsageData,
} from "@/api/api";

export default {
  components: { 
    countTo,
  },
  data() {
    return {
      userId:"",
      startVal: 0,
      totalStatisticData:{
        accountBalance: 0,
        totalCardNumber: 0,
        currentMonthAddCardNumber:0,
        monthActiveCardNumber:0,
        stopCardNumber:0,
      },
      pondList:[],
      activePoolId:"",
      cardOperatorEchartsPieData:[],
      lifeCycleEchartsPieData:[],
      cardNumberByMonthEchartsBarData:[
            { value: 0, itemStyle: {color: '#FA897B'}},
            { value: 0, itemStyle: { color: '#D0E6A5'}},
            {value: 0, itemStyle: {color: '#4675C0'}},
            {value: 0, itemStyle: {color: '#64A4D6'}},
            {value: 0,itemStyle: {color: '#bdc2e8'}},
            {value: 0,itemStyle: {color: '#FFA876'}}
      ],
      cardNumberByMonthEchartsBarTimeList:[],
      sixMonthsExpenseEchartsBarData:[],
      sixMonthsEchartsBarTimeList:[],
      flowUsageEchartsLineData:[],
      flowUsageEchartsLineTimeList:[],
      flowUsageMode:"按日",
      flowUsageModeList: ["按日","按月"],
      flowUnit:"MB",
      flowName:"日流量",
      cardMonthFlowTopData:[],
      currentMonthFlowEchartsLiquidFillData:[0.00,0.00,0.00,0.00],
      currentMonthFlowTotalFlow:0.00,
      currentMonthFlowUseFlow:0.00,
      historyUsageEchartsLineData:[],
      historyUsageEchartsLineTimeList:[],
    };
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
    username:{
      get() {
          return this.$store.getters.name
      }
    }
  },
  methods: {
    // 初始化获取数据
    initData(){
      let params = {
        userId:this.userId,
        status:"1"
      }
      poolGetFlowPoolList(params).then(res=>{
        this.pondList = res.data.data;
        this.activePoolId = this.pondList[0].id;
        this.getTotalStatisticData();
        this.getCardOperatorEchartsPieData();
        this.getLifeCycleEchartsPieData();
        this.getCardNumberByMonthEchartsBarData();
        this.getSixMonthsEchartsBarData();
        this.getFlowUsageEchartsLineData();
        this.getCardMonthFlowTopData();
        this.getCurrentMonthFlowEchartsLiquidFillData();
        this.getHistoryUsageEchartsLineData();
      })
    },

    // 获取运营统计数据
    getTotalStatisticData(){
      // if(!this.checkPermi(['statistic:pool:totalStatisticData'])){
      //   return false;
      // }
      totalStatisticData({userId:this.userId}).then(res=>{
        if (res.data.code == 200) {
          if(res.data.data){
            this.totalStatisticData = res.data.data;
          }
        }
      })
    },
    stopInfo(){
      this.$router.push("/pondManage/poolCardStopWarn/" + this.userId
      );
    },

    // tab切换
    handleTabClick(tab){
      this.activePoolId = tab.name;
      this.getTotalStatisticData();
      this.getCardOperatorEchartsPieData();
      this.getLifeCycleEchartsPieData();
      this.getCardNumberByMonthEchartsBarData();
      this.getSixMonthsEchartsBarData();
      this.getFlowUsageEchartsLineData();
      this.getCardMonthFlowTopData();
      this.getCurrentMonthFlowEchartsLiquidFillData();
      this.getHistoryUsageEchartsLineData();
    },

    // 卡运营商分布饼图
    getCardOperatorEchartsPieData(){
      // if(!this.checkPermi(['statistic:pool:cardOperatorPieData'])){
      //   return false;
      // }
      cardOperatorPieData({poolId:this.activePoolId}).then(res=>{
        if (res.data.code == 200) {
          if(res.data.data.length !== 0){
            this.cardOperatorEchartsPieData = res.data.data;
          } else {
            this.cardOperatorEchartsPieData = [
              { "name": "中国电信", "value": 0}, { "name": "中国移动","value": 0},{ "name": "中国联通", "value": 0},
            ]
          }
          this.cardOperatorEcharts();
        }
      })
    },
    cardOperatorEcharts(){
      setTimeout(() => {
        let option = {
          tooltip: {
            trigger: 'item',
          },
          legend: {
            y: "280px",
          },
          series: [
            {
              name: '卡运营商分布',
              type: 'pie',
              itemStyle: {
                borderRadius: 5,
                borderColor: '#fff',
                borderWidth: 2,
              },
              data:this.cardOperatorEchartsPieData
            }
          ]
        };
        let cardOperatorEcharts = echarts.init(document.getElementById("cardOperatorEcharts"));
        option && cardOperatorEcharts.setOption(option);
        window.addEventListener("resize",function(){
          cardOperatorEcharts.resize()
        });
      },80)
    },

    // 生命周期饼图
    getLifeCycleEchartsPieData(){
      // if(!this.checkPermi(['statistic:pool:lifeCycleEcharts'])){
      //   return false;
      // }
      lifeCyclePieData({poolId:this.activePoolId}).then(res=>{
        if (res.data.code == 200) {
          if(res.data.data.length !== 0){
            this.lifeCycleEchartsPieData = res.data.data;
          } else {
            this.lifeCycleEchartsPieData = [
              { "name": "待激活","value": 0}, { "name": "已激活", "value": 0},{ "name": "已停机", "value": 0},
            ]
          }
          this.lifeCycleEcharts();
        }
      })
    },
    lifeCycleEcharts(){
      setTimeout(() => {
        let option = {
          tooltip: {
            trigger: 'item',
          },
          legend: {
            y: "280px",
          },
          series: [
            {
              name: '生命周期分布',
              type: 'pie',
              radius: ['35%', '65%'],
              barMinHeight: 150,
              itemStyle: {
                borderRadius: 5,
                borderColor: '#fff',
                borderWidth: 2,
                normal: {
                  color: function (colors) {
                    let colorList = [
                      '#fc8251',
                      '#5470c6',
                      '#91cd77',
                      '#f9c956',
                      '#75bedc',
                      '#ef6567',

                    ];
                    return colorList[colors.dataIndex];
                  }
                },
              },
              data:this.lifeCycleEchartsPieData
            }
          ]
        };
        let lifeCycleEcharts = echarts.init(document.getElementById("lifeCycleEcharts"));
        option && lifeCycleEcharts.setOption(option);
        window.addEventListener("resize",function(){
          lifeCycleEcharts.resize()
        });
      },80)
    },

    // 月入池卡数统计柱形图
    getCardNumberByMonthEchartsBarData() {
      // if(!this.checkPermi(['statistic:pool:cardNumberByMonthEcharts'])){
      //   return false;
      // }
      cardNumberByMonthBarData({poolId:this.activePoolId}).then(res => {
        let data = res.data.data;
        data.forEach((el, index) => {
          this.cardNumberByMonthEchartsBarTimeList[index] = el.name;
          this.cardNumberByMonthEchartsBarData[index].value = el.value;
        });
        this.cardNumberByMonthEcharts();
      });
    },
    cardNumberByMonthEcharts() {
      let seriesData = [
        {
          name: "月入池卡数",
          type: "bar",
          barGap: "0",
          barWidth: "30%",
          data: this.cardNumberByMonthEchartsBarData,
        },
      ];
      setTimeout(() => {
        let option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "280px",
          },
          color: [ "#36A3F7","#B6A2DE",'#30C7C9',"#36A3F7","#B6A2DE",'#30C7C9'],
          xAxis: [
            {
              type: "category",
              data: this.cardNumberByMonthEchartsBarTimeList,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                //坐标轴轴线相关设置。
                lineStyle: {
                  color: "#2B2F3A",
                }
              },
              axisLabel: {
                interval:0,
                rotate:0//角度顺时针计算的
              }
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#409EFF",
              fontSize: 14,
              padding: [0, 0, 10, -12]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value",
            name:"单位：张",
          },
          grid:{
            right: "20px",
          },
          animationDuration: 2000, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: seriesData,
        };
        let cardNumberByMonthEcharts = echarts.init(document.getElementById("cardNumberByMonthEcharts"));
        option && cardNumberByMonthEcharts.setOption(option);
        window.addEventListener("resize",function(){
          cardNumberByMonthEcharts.resize();
        });
      },80)
    },

    // 近六个月费用统计柱形图
    getSixMonthsEchartsBarData() {
      if(!this.adminShow){
        return false;
      }
      sixMonthsExpenseBarData({poolId:this.activePoolId}).then(res => {
        let data = res.data.data;
        data.forEach((el, index) => {
          this.sixMonthsEchartsBarTimeList[index] = el.name;
          this.sixMonthsExpenseEchartsBarData[index] = el.value?el.value:0;
        });
        this.sixMonthsEcharts();
      });
    },
    sixMonthsEcharts() {
      let seriesData = [
        {
          name: "月费用",
          type: "bar",
          barGap: "0",
          barWidth: "30%",
          data: this.sixMonthsExpenseEchartsBarData
        },
      ];
      setTimeout(() => {
        let option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "280px",
          },
          color: [ "#36A3F7","#B6A2DE",'#30C7C9',"#36A3F7","#B6A2DE",'#30C7C9'],
          xAxis: [
            {
              type: "category",
              data: this.sixMonthsEchartsBarTimeList,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                //坐标轴轴线相关设置。
                lineStyle: {
                  color: "#2B2F3A",
                }
              },
              axisLabel: {
                interval:0,
                rotate:0//角度顺时针计算的
              }
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#409EFF",
              fontSize: 14,
              padding: [0, 0, 10, -12]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value",
            name:"单位：元",
          },
          animationDuration: 2000, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: seriesData,
        };
        let sixMonthsEcharts = echarts.init(document.getElementById("sixMonthsEcharts"));
        option && sixMonthsEcharts.setOption(option);
        window.addEventListener("resize",function(){
          sixMonthsEcharts.resize();
        });
      },80)
    },

    // 流量使用量
    changeFlowUsageMode(){
      this.getFlowUsageEchartsLineData();
    },
    getFlowUsageEchartsLineData(){
      if(!this.adminShow){
        return false;
      }
      flowUsageData({poolId:this.activePoolId,mode:this.flowUsageMode}).then(res=>{
        if (res.data.code == 200) {
          this.flowUsageEchartsLineTimeList = [];
          this.flowUsageEchartsLineData = [];
          let data = res.data.data;
          data.forEach((el, index) => {
            this.flowUsageEchartsLineTimeList.push(el.name);
            if(this.flowUsageMode === "按日"){
              this.flowUsageEchartsLineData.push(el.value?(el.value/1).toFixed(2):0);
              this.flowUnit = "MB";
              this.flowName = "日流量";
            } else {
              this.flowUsageEchartsLineData.push(el.value?(el.value/1024).toFixed(2):0);
              this.flowUnit = "GB";
              this.flowName = "月流量";
            }
          });
          this.flowUsageEcharts();
        }
      })
    },
    flowUsageEcharts(){
      setTimeout(() => {
        let seriesData = [
          {
            name: this.flowName,
            type: "line",
            lineStyle:{
              color: "#409EFF",
            },
            data: this.flowUsageEchartsLineData,
          },
        ];
        let option = {
          color: [ "#36A3F7","#B6A2DE",'#30C7C9',"#36A3F7","#B6A2DE",'#30C7C9'],
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "280px",
          },
          xAxis: [
            {
              type: "category",
              data: this.flowUsageEchartsLineTimeList,
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#409EFF",
              fontSize: 14,
              padding: [0, 0, 10, -12]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value",
            name:"单位：" + this.flowUnit,
          },
          animationDuration: 1500, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: seriesData,
        };
        let flowUsageEcharts = echarts.init(document.getElementById("flowUsageEcharts"));
        option && flowUsageEcharts.setOption(option);
        window.addEventListener("resize",function(){
          flowUsageEcharts.resize()
        });
      },80)
    },

    // 卡月流量TOP5
    getCardMonthFlowTopData(){
      if(!this.adminShow){
        return false;
      }
      cardMonthFlowTopData({poolId:this.activePoolId}).then(res => {
        this.cardMonthFlowTopData = res.data.data;
      });
    },
    cardInfo(iccid){
      if(this.adminShow){
        this.$router.push({path:"/card/detail",query:{iccid: iccid}});
      }
    },

    // 本月流量使用情况
    getCurrentMonthFlowEchartsLiquidFillData() {
      // if(!this.checkPermi(['statistic:pool:currentMonthFlowEcharts'])){
      //   return false;
      // }
      currentMonthFlowData({poolId:this.activePoolId}).then(res => {
        let data = res.data.data;
        if(data.totalFlow > 0){
          this.currentMonthFlowEchartsLiquidFillData = [
            (data.useFlow/data.totalFlow-0.02).toFixed(2),
            (data.useFlow/data.totalFlow-0.01).toFixed(2),
            (data.useFlow/data.totalFlow).toFixed(2),
            (data.useFlow/data.totalFlow+0.01).toFixed(2),
          ];
        }
        this.currentMonthFlowTotalFlow = (data.totalFlow/1024).toFixed(2);
        this.currentMonthFlowUseFlow = (data.useFlow/1024).toFixed(2);
        this.currentMonthFlowEcharts();
      });
    },
    currentMonthFlowEcharts() {
      let seriesData = [
        {
          name: "月流量",
          shape: 'circle',
          type: "liquidFill",
          radius: '80%',
          direction: 'right',
          center: ['50%', '50%'],
          amplitude: '8%',
          waveLength: '80%',
          phase: 'auto',
          period: 'auto',
          waveAnimation: true,
          animationEasing: 'linear',
          animationEasingUpdate: 'linear',
          animationDuration: 2000,
          animationDurationUpdate: 1000,
          outline: {
            show: true,
            borderDistance: 8,
            itemStyle: {
              color: 'none',
              borderColor: '#A8D1FE',
              borderWidth: 8,
              shadowBlur: 20,
              shadowColor: 'rgba(0, 0, 0, 0.25)'
            }
          },
          backgroundStyle: {
            color: '#E3F7FF'
          },
          label: {
            show: true,
            color: '#A8D1FE',
            insideColor: '#fff',
            fontSize: 50,
            fontWeight: 'bold',
            align: 'center',
            baseline: 'middle',
            position: 'inside',
            normal: {
              formatter: this.currentMonthFlowTotalFlow + 'GB\n'+this.currentMonthFlowUseFlow+'GB(已使用)',
              textStyle: {
                fontSize: 28,
                color:"#5391FF"
              }
            }
          },
          emphasis: {
            itemStyle: {
              opacity: 0.8
            }
          },
          data: this.currentMonthFlowEchartsLiquidFillData
        },
      ];
      setTimeout(() => {
        let option = {
          tooltip: {
            trigger: "axis",
          },
          series: seriesData,
        };
        let currentMonthFlowEcharts = echarts.init(document.getElementById("currentMonthFlowEcharts"));
        option && currentMonthFlowEcharts.setOption(option);
        window.addEventListener("resize",function(){
          currentMonthFlowEcharts.resize();
        });
      },80)
    },

    // 历史流量情况
    getHistoryUsageEchartsLineData() {
      // if(!this.checkPermi(['statistic:pool:lifeCycleEcharts'])){
      //   return false;
      // }
      historyUsageData({poolId:this.activePoolId}).then(res => {
        let data = res.data.data;
        data.forEach((el, index) => {
          this.historyUsageEchartsLineTimeList[index] = el.name;
          this.historyUsageEchartsLineData[index] = el.value?(el.value/1024).toFixed(2):0;
        });
        this.historyUsageEcharts();
      });
    },
    historyUsageEcharts() {
      let seriesData = [
        {
          name: "月流量",
          smooth:true,
          type: "line",
          areaStyle:{
            color:'#A8D1FE',
          },
          data: this.historyUsageEchartsLineData
        },
      ];
      setTimeout(() => {
        let option = {
          tooltip: {
            trigger: "axis",
          },
          legend: {
            y: "360px",
          },
          color: [ "#36A3F7","#B6A2DE",'#30C7C9',"#36A3F7","#B6A2DE",'#30C7C9'],
          xAxis: [
            {
              type: "category",
              data: this.historyUsageEchartsLineTimeList,
              axisPointer: {
                type: "shadow",
              },
              axisLine: {
                //坐标轴轴线相关设置。
                lineStyle: {
                  color: "#2B2F3A",
                }
              },
              axisLabel: {
                interval:0,
                rotate:0//角度顺时针计算的
              }
            },
          ],
          yAxis: {
            nameTextStyle: {
              color: "#409EFF",
              fontSize: 16,
              padding: [0, 0, 10, -20]
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#2B2F3A"
              }
            },
            type: "value",
            name:"单位：GB",
          },
          grid:{
            right: "20px",
          },
          animationDuration: 2000, //动画时间
          animationEasing: 'BounceOut',  //BounceOut设置动画效果 cubicInOut
          series: seriesData,
        };
        let historyUsageEcharts = echarts.init(document.getElementById("historyUsageEcharts"));
        option && historyUsageEcharts.setOption(option);
        window.addEventListener("resize",function(){
          historyUsageEcharts.resize();
        });
      },80)
    },

  },
  mounted() {
  },
  created() {
    if(this.adminShow){
      this.userId = this.$route.query && this.$route.query.userId;
    } else {
      this.userId = this.$store.getters.user.userId;
    }
    this.initData();
  },
};
</script>
<style scoped lang="less">
  ::v-deep .el-radio-group {
    .el-radio-button {
      .el-radio-button__inner {
        height: 26px;
        margin-top: 8px;
        line-height: 6px;
        z-index: 999;
      }
    }
  }
  .el-select {
    height: 20px;
    /deep/ .el-input {
      .el-input__inner {
        height: 20px;
      }
      .el-input__prefix,
      .el-input__suffix {
        height: 20px;
      }
      /* 下面设置右侧按钮居中 */
      .el-input__suffix {
        top: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
      }
      /* 输入框加上上下边是 60px + 2px =62px */
      .el-input__icon {
        line-height: 22px;
      }
    }
  }

  .top-content {
    background: white;
    width: 92%;
    height: 320px;
    p{
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #E7EAF3;
      font-size: 14px;
      color: #899caf;
      margin: 0 auto;
    }
    .table-head{
      padding: 0 20px 0 20px;
      display: flex;
      justify-content: space-between;
      background: #F7F5F0;
      margin-top: 5px;
    }
    ul{
      padding: 0 20px 0 20px;
      li{
        height: 40px;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        color: #409EFF;
        font-size: 14px;
        cursor: pointer;
        .number-bg{
          display: inline-block;
          width: 16px;
          height: 16px;
          line-height: 18px;
          text-align: center;
          color: #fff;
          background: #fb973b;
          margin-right: 3px;
        }
      }
    }
    .top-default{
      justify-content: center;
      align-items: center;
      display: flex;
      flex-direction: row;
      margin-top: 30%;
      color: #899caf;
      font-size: 14px;
    }
  }
  .echart-bootom-tip{
    text-align: center;
    font-size: 12px
  }
  .box-card{
    background-color: rgb(240, 242, 245);
    margin-bottom: 10px;
  }
  .curClass{
    margin-left: 10px;
    padding:0 2px;
    font-size: 14px !important;
  }
  .box {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: left;
  }
  .line{
    width: 2px;
    height: 16px;
    line-height: 16px;
    background-color: #626365;
    display: inline-block;
    margin-right: 10px;
  }
  .box p span {
    font-size: 20px;
    color: #626365;
    font-weight: 300;
  }
  .order {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
  }
  .order .lists {
    width: 13.3%;
    height: 108px;
    cursor: pointer;
    display: flex;
    background:#30C7C9;
    border-radius: 10px;
  }
  .listsxianshi{
    position: relative;
  }
  .money-none{
    position: absolute;
    right: -90px;
    top: 6px;
    animation: dongHua normal 1.2s ease-in-out;
    p{
      width: 135px;
      font-size: 14px;
      text-align: left;
    }
  }
  @-webkit-keyframes dongHua {
    0% {
        opacity:0.1;
    }
    25% {
        opacity:0.25;
    }
    50% {
        opacity:0.5;
    }
    75% {
        opacity:0.75;
    }
    100% {
        opacity:1;
    }
  }
  .down-class{
    display: flex;
    flex-direction: column ;
    color:#666666;
    div{
      width: 100%;
      height: 54px;
    }
    .left{
      text-align: center;
      position: relative;
      left: 15px;
      top:10px
    }
    .right{
      text-align: center;
      position: relative;
      right: 30px;
    }
  }
  .imgs {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .pool-icon{
    width: 50px;
    height: 108px;
    line-height: 108px;
    margin-left: 20px;
    margin-right: 20px;
    text-align: right;
  }
  .amount {
    flex: 1;
    height: 108px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }
  .amount p {
    font-size: 18px;
    color: #666666;
    font-weight: bold;
    margin-top: 5px;
  }
  .amount:hover{
    transition: 0.4s;
    transform: scale(1.2);
  }
  .topCard:hover{
    transition: 0.4s;
    transform: scale(1.1);
  }
  .cur {
    color: #fff !important;
    background-color:#30C7C9;
    border-color:#30C7C9;
  }

  .cardNumberByMonthEchartsClass,.sixMonthsEchartsClass,.flowUsageEchartsClass, .currentMonthFlowEchartsClass, .historyUsageEchartsClass{
    width: 98%;
    height: 320px;
    margin-top: 10px;
    background: #fff;
    border: 1px solid rgba(83,130,152,.2);
  }
  @media screen and (max-width: 750px){
    .box p span{
      font-size: 22px;
    }
    .order{
      margin-top: 40px;
      flex-direction: column;
    }
    .lists{
      width: 100%!important;
      margin-top: 3px;
    }
    .panel-block{
      flex-direction: column;
    }
    .white-box{
      width: 100%!important;
    }
    .wrapl{
      width: 100%!important;
    }
    .wrapr{
      display: inline!important;
    }
    .money-none{
      position: absolute;
      right: -15px;
      top: 15px;
      p{
        width: 135px;
        font-size: 14px;
        text-align: right;
      }
    }
  }
</style>


